import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';


@Component({
  template: `
  <h1 mat-dialog-title>Create new folder</h1>
  <form [formGroup]="form" (ngSubmit)="submit(form)">
  <mat-dialog-content>
    <mat-form-field>
      <input matInput formControlName="nombre" placeholder="Name">
    </mat-form-field>
    </mat-dialog-content>
  <mat-dialog-actions>
    <button mat-button type="submit" color="accent" [disabled]="form?.invalid">Guardar</button>
    <button mat-button type="button" (click)="onNoClick()">Cancelar</button>
  </mat-dialog-actions>
</form>`,
})
export class NewFolderComponent implements OnInit  {

  form: FormGroup;

  constructor(
    private formBuilder: FormBuilder,
    private dialogRef: MatDialogRef<NewFolderComponent>,
    @Inject(MAT_DIALOG_DATA) public data
  ) { }

  ngOnInit() {
    this.form = this.formBuilder.group({
        nombre: ['', Validators.required]
    });
  }

  submit(form) {
    this.dialogRef.close(form.value.nombre);
  }

  onNoClick(): void {
    this.dialogRef.close();
  }
}



// WEBPACK FOOTER //
// ./src/app/core/new-folder/new-folder.component.ts